// extracted by mini-css-extract-plugin
export default {"table":"SortableTable_table__1-kCz","heading":"SortableTable_heading__-G5BU","filters":"SortableTable_filters__21kxg"};